<!-- 商品管理 V2 方案 - 标签信息配置 -->
<template>
  <section class="tag-settings">
    <div class="section-title">
      <h3>标签信息</h3>
      <div class="section-actions">
        <el-button class="history-button" @click="openHistoryTag">历史标签</el-button>
        <el-button class="green-button" @click="addTag">添加新标签</el-button>
        <el-button class="red-button" @click="openMaintainedTag">选择已维护标签</el-button>
      </div>
    </div>

    <!-- 标签卡片列表：字段展示 + 条码预览 -->
    <div v-if="tags.length" class="tag-list">
      <div v-for="(tag, tagIndex) in tags" :key="tag.id || tagIndex" class="tag-card">
        <div class="tag-card-main">
          <div class="tag-card-head">
            <strong>{{ tagTypeName(tag.type) }}</strong>
            <div class="tag-actions">
              <i class="el-icon-edit-outline" title="编辑" @click="editTag(tag, tagIndex)"></i>
              <i class="el-icon-printer" title="打印" @click="printTag(tag)"></i>
              <i class="el-icon-delete" title="删除" @click="tags.splice(tagIndex, 1)"></i>
            </div>
          </div>
          <p><span>{{ $t('message.labelNo') }}</span><em>{{ tag.no }}</em></p>
          <p><span>编码格式</span><em>{{ tag.code_type }}</em></p>
          <p><span>{{ $t('message.commodityCode') }}</span><em>{{ tag.goods_no }}</em></p>
          <p><span>标签文字（1）</span><em>{{ tag.text_line_one }}</em></p>
          <p><span>标签文字（2）</span><em>{{ tag.text_line_two }}</em></p>
          <p><span>标签文字（3）</span><em>{{ tag.text_line_three }}</em></p>
          <p><span>标签文字（4）</span><em>{{ tag.text_line_four }}</em></p>
        </div>
        <div class="tag-barcode">
          <svg :ref="'barcode-' + tagIndex"></svg>
          <p class="barcode-no">{{ tag.no }}</p>
          <p>{{ tag.text_line_one }}</p>
          <p>{{ tag.text_line_two }}</p>
          <p>{{ tag.text_line_three }}</p>
          <p>{{ tag.text_line_four }}</p>
        </div>
      </div>
    </div>
    <div v-else class="empty-block">暂无标签</div>

    <history-tag-dialog ref="historyTagDialog" @confirm="onTagConfirm" />
    <maintained-tag-dialog ref="maintainedTagDialog" @confirm="onTagConfirm" />
    <tag-edit-dialog ref="tagEditDialog" :tag-list="tagTypeList" @save="onTagSave" />
  </section>
</template>

<script>
import JsBarcode from 'jsbarcode'
import HistoryTagDialog from './historyTagDialog'
import MaintainedTagDialog from './maintainedTagDialog'
import TagEditDialog from './tagEditDialog'

/**
 * 贩售方案标签管理
 * 支持历史标签、已维护标签、新建/编辑/打印，JsBarcode 生成预览
 */
export default {
  name: 'PlanTagSettings',
  components: { HistoryTagDialog, MaintainedTagDialog, TagEditDialog },
  props: {
    tags: { type: Array, required: true },
    detail: { type: Object, required: true }
  },
  data() {
    return {
      tagTypeList: [] // 标签类型下拉（orderDetailTagList）
    }
  },
  watch: {
    tags: {
      handler() {
        this.$nextTick(this.renderBarcodes)
      },
      deep: true
    }
  },
  created() {
    this.$api.clienteleApi.orderDetailTagList({}).then(res => {
      this.tagTypeList = res.data
    })
  },
  mounted() {
    this.renderBarcodes()
  },
  methods: {
    tagTypeName(type) {
      const tagType = this.tagTypeList.find(item => item.type === type)
      return tagType ? tagType.remark : type
    },
    openHistoryTag() {
      this.$refs.historyTagDialog.open(this.detail.sys_code, this.detail.user_id)
    },
    openMaintainedTag() {
      this.$refs.maintainedTagDialog.open(this.detail.client_product_tag)
    },
    addTag() {
      this.$refs.tagEditDialog.open()
    },
    editTag(tag, index) {
      this.$refs.tagEditDialog.edit(tag, index)
    },
    printTag(tag) {
      this.$refs.tagEditDialog.printTag(tag)
    },
    onTagConfirm(tag) {
      this.tags.push(tag)
    },
    onTagSave(tag, index) {
      if (index === null) {
        this.tags.push(tag)
      } else {
        this.$set(this.tags, index, tag)
      }
    },
    // 根据标签号与编码格式渲染条码 SVG
    renderBarcodes() {
      this.tags.forEach((tag, index) => {
        const refs = this.$refs['barcode-' + index]
        const element = Array.isArray(refs) ? refs[0] : refs
        if (!element || !tag.no) return
        try {
          JsBarcode(element, tag.no, {
            format: tag.code_type === 'EN13' ? 'EAN13' : tag.code_type === 'EN8' ? 'EAN8' : tag.code_type,
            displayValue: false,
            height: 50,
            width: 1.2,
            margin: 0
          })
        } catch (error) {
          // 标签号与编码格式不匹配时不生成预览。
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-settings { box-sizing: border-box; width: 100%; margin-top: 24px; padding: 24px; border-radius: 8px; background: #fff; }
.section-title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.section-title h3 { margin: 0; font-size: 16px; }
.section-actions { display: flex; gap: 10px; }
.section-actions .el-button { margin: 0; }
.history-button { border-color: #e6a23c; background: #e6a23c; color: #fff; }
.green-button { border-color: #15ad3c; background: #15ad3c; color: #fff; }
.red-button { border-color: #b4272d; background: #b4272d; color: #fff; }
.tag-list { display: flex; flex-wrap: nowrap; gap: 16px; max-width: 100%; overflow-x: auto; padding-bottom: 8px; }
.tag-card { box-sizing: border-box; display: flex; flex: 0 0 620px; width: 620px; min-width: 620px; padding: 18px; border: 1px solid #e5e5e5; border-radius: 6px; background: #fff; }
.tag-card-main { box-sizing: border-box; flex: 0 0 360px; min-width: 360px; padding: 14px; border: 1px solid #e5e5e5; border-radius: 4px; font-size: 14px; }
.tag-card-head { display: flex; align-items: center; justify-content: space-between; min-height: 24px; margin-bottom: 10px; }
.tag-actions { display: flex; gap: 12px; }
.tag-actions i { color: #315ede; font-size: 17px; cursor: pointer; }
.tag-actions .el-icon-delete { color: #e05a61; }
.tag-card-main p { display: flex; align-items: center; margin: 0 0 6px; line-height: 22px; }
.tag-card-main span { flex: 0 0 118px; margin-right: 8px; color: #666; }
.tag-card-main em { flex: 1; min-width: 0; overflow: hidden; color: #333; font-style: normal; text-align: right; text-overflow: ellipsis; white-space: nowrap; }
.tag-barcode { box-sizing: border-box; flex: 0 0 190px; width: 190px; min-width: 190px; margin-left: 24px; color: #333; font-size: 12px; text-align: center; }
.tag-barcode svg { max-width: 100%; }
.tag-barcode p { overflow: hidden; margin: 2px 0; text-align: left; text-overflow: ellipsis; white-space: nowrap; }
.tag-barcode .barcode-no { text-align: center; }
.empty-block { padding: 35px 0; color: #999; text-align: center; }
</style>
